// hooks/useUsuario.ts
import { useState, useEffect } from "react";
import { enderecoService } from "../services/enderecoService";
import { Endereco } from "../interfaces/Endereco";

export const useEndereco = (
  usuarioId: number | undefined | null,
  fetch: boolean
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [endereco, setEndereco] = useState<Endereco | undefined>(undefined);

  useEffect(() => {
    const fetchEndereco = async () => {
      if (usuarioId && fetch) {
        setIsLoading(true);
        try {
          const data = await enderecoService(usuarioId);

          setEndereco(data);
        } catch (error) {
          console.error("Erro ao buscar endereço:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchEndereco();
  }, [usuarioId, fetch]); // Dependência de usuarioId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, endereco };
};
